'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var Handlebars = (0, _handlebars2.default)();
    /*= ===========================================================================
    Ajax the add to cart experience by revealing it in a side drawer
    Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
    (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.
    This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin
    This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid
    Customized version of Shopify's jQuery API
    (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
    ============================================================================== */
    var ShopifyAPI = {};

    /*= ===========================================================================
    API Helper Functions
    ============================================================================== */
    function attributeToString(attribute) {
        var attr = attribute;
        if (typeof attr !== 'string') {
            attr += '';
            if (attr === 'undefined') {
                attr = '';
            }
        }
        return jQuery.trim(attr);
    }

    /*= ===========================================================================
    API Functions
    ============================================================================== */
    ShopifyAPI.onCartUpdate = function (cart) {
        console.log('There are now ' + cart.item_count + ' items in the cart.');
    };

    ShopifyAPI.updateCartNote = function (note, callback) {
        var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            success: function success(cart) {
                if (typeof callback === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
            },
            error: function error(XMLHttpRequest, textStatus) {
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
        };
        jQuery.ajax(params);
    };

    ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        if (data.message) {
            alert(data.message + '(' + data.status + '): ' + data.description);
        }
    };

    /*= ===========================================================================
    POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
    ============================================================================== */
    ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
        var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            success: function success(line_item) {
                if (typeof callback === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
            },
            error: function error(XMLHttpRequest, textStatus) {
                if (typeof errorCallback === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
            }
        };
        jQuery.ajax(params);
    };

    // Get from cart.js returns the cart in JSON
    ShopifyAPI.getCart = function (callback) {
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
            if (typeof callback === 'function') {
                callback(cart);
            } else {
                ShopifyAPI.onCartUpdate(cart);
            }
        });
    };

    // POST to cart/change.js returns the cart in JSON
    ShopifyAPI.changeItem = function (line, quantity, callback) {
        var params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            success: function success(cart) {
                if (typeof callback === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
            },
            error: function error(XMLHttpRequest, textStatus) {
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
        };
        jQuery.ajax(params);
    };

    /*= ===========================================================================
    Ajax Shopify Add To Cart
    ============================================================================== */
    var ajaxCart = function (module, $) {
        var $formContainer = $('.ajaxAddToCart');
        var $cartContainer = $('#CartContainer');
        var $emptyContainer = $('#emptyCartContainer');
        var $addToCart = $('.ajaxAddToCartBtn');
        var $cartCountSelector = $('#CartCount');
        var $cartCostSelector = $('#CartCost');

        // General Selectors
        var $body = $('body');

        var loadCart = function loadCart() {
            $body.addClass('drawer--is-loading');
            ShopifyAPI.getCart(cartUpdateCallback);
        };

        var updateCountPrice = function updateCountPrice(cart) {
            if ($cartCountSelector) {
                $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

                if (cart.item_count === 0) {
                    $cartCountSelector.addClass('hidden-count');
                }
            }
            if ($cartCostSelector) {
                $cartCostSelector.html((0, _themeCurrency.formatMoney)(cart.total_price, theme.moneyFormat));
            }
        };

        var formOverride = function formOverride() {
            $formContainer.on('submit', function (evt) {
                evt.preventDefault();
                var $form = $(evt.currentTarget);

                // Add class to be styled if desired
                $form.find($addToCart).removeClass('is-added').addClass('is-adding');

                // Remove any previous quantity errors
                $('.qty-error').remove();

                ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
            });
        };

        var itemAddedCallback = function itemAddedCallback(product, form) {
            $(form).find($addToCart).removeClass('is-adding').addClass('is-added');

            ShopifyAPI.getCart(cartUpdateCallback);
            if ($(form).find($addToCart).hasClass('bundleAddToCart')) return;
            $('.cart-button').trigger('click');
        };

        var itemErrorCallback = function itemErrorCallback(XMLHttpRequest, textStatus) {
            var data = eval('(' + XMLHttpRequest.responseText + ')');
            $addToCart.removeClass('is-adding is-added');

            if (data.message) {
                if (data.status == 422) {
                    $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
                }
            }
        };

        var cartCallback = function cartCallback(cart) {
            $body.removeClass('drawer--is-loading');
            $body.trigger('ajaxCart.afterCartLoad', cart);
        };

        var buildCart = function buildCart(cart) {
            // Start with a fresh cart div
            $cartContainer.empty();

            // Show empty cart
            if (cart.item_count === 0) {
                $emptyContainer.show();

                cartCallback(cart);
                return;
            }

            // Handlebars.js cart layout
            var item = {};
            var data = {};
            var items = [];
            var source = $('#CartTemplate').html();
            var template = Handlebars.compile(source);

            // Add each item to our handlebars.js data
            $.each(cart.items, function (index, cartItem) {
                /* Hack to get product image thumbnail
                *   - If image is not null
                *     - Remove file extension, add _small, and re-add extension
                *     - Create server relative link
                *   - A hard-coded url of no-image
                */
                var prodImg = '';
                if (cartItem.image != null) {
                    prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
                } else {
                    prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
                }

                // Create item's data object and add to 'items' array
                item = {
                    id: cartItem.variant_id,
                    line: index + 1, // Shopify uses a 1+ index in the API
                    url: cartItem.url,
                    img: prodImg,
                    name: cartItem.product_title,
                    variation: cartItem.variant_title,
                    properties: cartItem.properties,
                    itemAdd: cartItem.quantity + 1,
                    itemMinus: cartItem.quantity - 1,
                    itemQty: cartItem.quantity,
                    price: (0, _themeCurrency.formatMoney)(cartItem.price, theme.moneyFormat),
                    vendor: cartItem.vendor
                };

                items.push(item);
            });

            // Gather all cart data and add to DOM
            data = {
                items: items,
                note: cart.note,
                totalPrice: (0, _themeCurrency.formatMoney)(cart.total_price, theme.moneyFormat)
            };

            $cartContainer.append(template(data));

            cartCallback(cart);
        };

        var cartUpdateCallback = function cartUpdateCallback(cart) {
            // Update quantity and price
            updateCountPrice(cart);
            buildCart(cart);
        };

        var validateQty = function validateQty(qty) {
            var newQty = qty;
            if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
                // We have a valid number!
            } else {
                // Not a number. Default to 1.
                newQty = 1;
            }
            return newQty;
        };

        var adjustCartCallback = function adjustCartCallback(cart) {
            // Update quantity and price
            updateCountPrice(cart);

            // Reprint cart on short timeout so you don't see the content being removed
            setTimeout(function () {
                ShopifyAPI.getCart(buildCart);
            }, 150);
        };

        var adjustCart = function adjustCart() {
            // Delegate all events because elements reload with the cart

            // Add or remove from the quantity
            $body.on('click', '.ajaxcart__qty-adjust', function () {
                var $el = $(this);
                var line = $el.data('line');
                var $qtySelector = $el.parents('.ajaxcart__qty').find('.ajaxcart__qty-num');
                var qty1 = parseInt($qtySelector.val().replace(/\D/g, ''), 10);

                var qty = validateQty(qty1);

                // Add or subtract from the current quantity
                if ($el.hasClass('ajaxcart__qty--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 0) qty = 0;
                }

                // If it has a data-line, update the cart.
                // Otherwise, just update the input's number
                if (line) {
                    updateQuantity(line, qty);
                } else {
                    $qtySelector.val(qty);
                }
            });

            // Update quantity based on input on change
            $body.on('change', '.ajaxcart__qty-num', function () {
                var $el = $(this);
                var line = $el.data('line');
                var qty1 = parseInt($el.val().replace(/\D/g, ''), 10);

                var qty = validateQty(qty1);

                // If it has a data-line, update the cart
                if (line) {
                    updateQuantity(line, qty);
                }
            });

            // Highlight the text when focused
            $body.on('focus', '.ajaxcart__qty-adjust', function () {
                var $el = $(this);
                setTimeout(function () {
                    $el.select();
                }, 50);
            });

            var updateQuantity = function updateQuantity(line, qty) {
                // Add activity classes when changing cart quantities
                var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

                if (qty === 0) {
                    $row.parent().addClass('is-removed');
                }

                // Slight delay to make sure removed animation is done
                setTimeout(function () {
                    ShopifyAPI.changeItem(line, qty, adjustCartCallback);
                }, 250);
            };

            // Save note anytime it's changed
            $body.on('change', 'textarea[name="note"]', function () {
                var newNote = $(this).val();

                // Update the cart note in case they don't click update/checkout
                ShopifyAPI.updateCartNote(newNote, function (cart) {});
            });

            // // Ajax Cart Note toggle
            // $body.on('ajaxCart.afterCartLoad', (event, cart) => {
            //     $('.ajaxcart__footer #CartSpecialInstructions').hide();
            //     $('#note_label').on('click', () => {
            //         $('.ajaxcart__footer #CartSpecialInstructions').slideToggle();
            //     });
            // });
        };

        var qtySelectors = function qtySelectors() {
            // Change number inputs to JS ones, similar to ajax cart but without API integration.
            // Make sure to add the existing name and id to the new input element
            var $numInputs = $('input[type="number"]');

            if ($numInputs.length) {
                $numInputs.each(function () {
                    var $el = $(this);
                    var currentQty = $el.val();
                    var inputName = $el.attr('name');
                    var inputId = $el.attr('id');

                    var itemAdd = currentQty + 1;
                    var itemMinus = currentQty - 1;
                    var itemQty = currentQty;

                    var source = $('#JsQty').html();
                    var template = Handlebars.compile(source);
                    var data = {
                        id: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                    // Append new quantity selector then remove original
                    $el.after(template(data)).remove();
                });

                // Setup listeners to add/subtract from the input
                $('.js-qty__adjust').on('click', function () {
                    var $el = $(this);
                    var $qtySelector = $el.parents('.js-qty').find('.js-qty__num');
                    var qty1 = parseInt($qtySelector.val().replace(/\D/g, ''), 10);

                    var qty = validateQty(qty1);

                    // Add or subtract from the current quantity
                    if ($el.hasClass('js-qty__adjust--plus')) {
                        qty += 1;
                    } else {
                        qty -= 1;
                        if (qty <= 1) qty = 1;
                    }

                    // Update the input's number
                    $qtySelector.val(qty);
                });

                $body.on('change', '.js-qty__num', function () {
                    var $el = $(this);
                    var $qtySelector = $el.siblings('.js-qty__num');
                    var qty1 = parseInt($qtySelector.val().replace(/\D/g, ''), 10);

                    var qty = validateQty(qty1);
                    var min = 1;

                    if (qty < min) {
                        qty = min;
                        $el.val(min);
                    }

                    // Update the input's number
                    $qtySelector.val(qty);
                });
            }
        };

        var init = function init() {
            // Select DOM elements

            // Setup ajax quantity selectors on the any template if enableQtySelectors is true
            qtySelectors();

            // Take over the add to cart form submit action if ajax enabled
            if ($addToCart.length) {
                formOverride();
            }

            // Run this function in case we're using the quantity selector outside of the cart
            adjustCart();
        };

        module = {
            init: init,
            load: loadCart
        };

        return module;
    }(ajaxCart || {}, jQuery);
    ajaxCart.init();

    $('.cart-button').on('click', function () {
        ajaxCart.load();
    });
};

var _themeCurrency = require('@shopify/theme-currency');

var _handlebars = require('../vendor/handlebars');

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }